const api = "https://credit-sgtj.onrender.com";
// const api = "http://localhost:2205";
export default api;
